import React from "react";
import axios from "axios";
import { Input, Form, TextArea, Button } from "semantic-ui-react";

import "./EventsForm.css";

const validateEmail = value => {
  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailPattern.test(value);
};

export default class EventsForm extends React.Component {
  constructor() {
    super();
    this.state = {
      about: "",
      name: "",
      email: "",
      invalidAbout: false,
      invalidName: false,
      invalidEmail: false,
      showSuccess: false,
      showError: false,
      showLoader: false
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  onEmailChange(e, data) {
    /* onEmailChange sets invalidEmail only to false to prevent the
    error styling from appearing when the user starts typing. */
    const isValid = validateEmail(data.value);
    const emailValidation = isValid ? { invalidEmail: !isValid } : {};
    this.setState({ ...emailValidation, email: data.value });
  }

  onNameChange(e, data) {
    const isValid = data.value !== "";
    const nameValidation = isValid ? { invalidName: !isValid } : {};
    this.setState({ ...nameValidation, name: data.value });
  }

  onAboutChange(e, data) {
    const isValid = data.value !== "";
    const aboutValidation = isValid ? { invalidAbout: !isValid } : {};
    this.setState({ ...aboutValidation, about: data.value });
  }

  onSubmit() {
    const { about, name, email } = this.state;

    this.setState({ showLoader: true }, () => {
      axios({
        method: "post",
        url:
          "https://t8yfya69k5.execute-api.us-east-1.amazonaws.com/default/send-wholesol-events-form",
        data: {
          title: "Events Form",
          fields: {
            about,
            name,
            email
          }
        },
        headers: {
          "X-Api-Key": "rncgAojb8d51faJYAGO6Z8HRxOY3I8W026ClIktC"
        }
      })
        .then(() => {
          this.toggleValidation("showSuccess");
        })
        .catch(() => {
          this.toggleValidation("showError");
        });
    });
  }

  getValidationContent() {
    const {
      invalidAbout,
      invalidName,
      invalidEmail,
      showError,
      showSuccess,
      showLoader
    } = this.state;
    if (showLoader) {
      return (
        <div className="loader">
          One Moment Please<span>.</span>
          <span>.</span>
          <span>.</span>
        </div>
      );
    }
    const content =
      invalidAbout || invalidName
        ? "Please fill in all fields"
        : invalidEmail
        ? "Invalid Email"
        : showError
        ? "Please Try Again!"
        : "Submit";
    return showSuccess ? "Thank you!" : content;
  }

  toggleValidation(error) {
    const resetText =
      error === "showSuccess" || error === "showError"
        ? { email: "", name: "", about: "" }
        : {};
    this.setState({ ...resetText, [error]: true, showLoader: false });
    if (error === "showError") {
      setTimeout(() => {
        this.setState({ showError: false });
      }, 2000);
    }
  }

  render() {
    const {
      about,
      name,
      email,
      invalidAbout,
      invalidName,
      invalidEmail,
      showError,
      showSuccess
    } = this.state;
    return (
      <div id="events-form-container">
        <Form size="huge">
          <Form.Field error={invalidAbout}>
            <TextArea
              rows={5}
              placeholder="Tell us more about your event!"
              onChange={(e, data) => this.onAboutChange(e, data)}
              value={about}
            />
          </Form.Field>
        </Form>
        <Input
          fluid
          size="mini"
          error={invalidName}
          placeholder="Name"
          onChange={(e, data) => this.onNameChange(e, data)}
          value={name}
        />
        <Input
          fluid
          size="mini"
          error={invalidEmail}
          placeholder="Email"
          onChange={(e, data) => this.onEmailChange(e, data)}
          value={email}
          onKeyPress={e => (e.key === "Enter" ? this.onSubmit() : () => null)}
        />
        <div>
          <Button
            size="huge"
            onClick={this.onSubmit}
            negative={invalidAbout || invalidName || invalidEmail || showError}
            positive={showSuccess}
          >
            {this.getValidationContent()}
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EventsForm/EventsForm.jsx